/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const CHALLENGE_EAST = 'east';
export const CHALLENGE_WEST = 'west';

export const MOBILE_RECAPTCHA_TYPES = ['ENTERPRISE_IOS', 'ENTERPRISE_ANDROID'];

// Captcha control signals returned on HTTP 400. The wording differs by backend:
// the captcha middleware says "additional challenge required" while rentals says
// "recaptcha challenge required, retry with v2 token", so match on the substring
// common to both. Mirrors shared-ui/recaptcha's marker list.
export const RECAPTCHA_CHALLENGE_REQUIRED = 'challenge required';
export const RECAPTCHA_CHALLENGE_FAILED = 'challenge failed';

export const RECAPTCHA_ERROR =
    'Our system has detected abnormal activity from your computer network. Please try again.';

export const CH_GRID = 'campingAvailabilityGridBooking';
export const CH_CAMPSITE_PAGE = 'reserveCampsiteBooking';
export const CH_CAMPSITE_LIST_PAGE = 'campsiteListBooking';
export const CH_I_GRID = 'itineraryGridBooking';
export const CH_V_GRID = 'itineraryVoyageursBooking';
export const CH_O_GRID = 'itineraryOkefenokeeBooking';
export const CH_RENTAL = 'create_reservation';
